<script>
  export let text;
  export let style = '';

  const statScoreClass = style ? `stat-score-${style}` : '';
</script>

<style>
  .score-filters-legend-item {
    display: inline-block;
    width: 126px;
  }

  .score-box {
    border: 1px solid #333;
    cursor: default;
    display: inline-block;
  }

  .text {
    padding-left: 5px;
    vertical-align: middle;
  }
</style>

<template lang="pug" src="./score-filters-legend-item.pug"></template>
